export const PROD_AD_UNIT_IDS = {
  bannerBottom: import.meta.env.VITE_ADMOB_BANNER_BOTTOM || "",
  bannerTop: import.meta.env.VITE_ADMOB_BANNER_TOP || "",
  interstitialExport: import.meta.env.VITE_ADMOB_INTERSTITIAL_EXPORT || "",
  interstitialGallery: import.meta.env.VITE_ADMOB_INTERSTITIAL_GALLERY || "",
  interstitialGeneration: import.meta.env.VITE_ADMOB_INTERSTITIAL_GENERATION || "",
  rewardedPremium: import.meta.env.VITE_ADMOB_REWARDED_PREMIUM || "",
  rewardedExportHd: import.meta.env.VITE_ADMOB_REWARDED_EXPORT_HD || "",
};
